<template>
  <div>
    <section class="flex">
      <!-- Calidad -->
      <article class="side">
        <h2 class="side-title">{{ $t('calidad.title') }}</h2>
        <p v-html="$t('calidad.descripcion')"></p>
        <p class="side-code">{{ $t('calidad.codigo') }}</p>

        <article class="side-detail">
          <h3 class="side-subtitle">{{ $t('calidad.mision.title') }}</h3>
          <p v-html="$t('calidad.mision.descripcion')"></p>
          <p class="side-code">{{ $t('calidad.mision.codigo') }}</p>
          <hr>
          <h3 class="side-subtitle">{{ $t('calidad.vision.title') }}</h3>
          <p v-html="$t('calidad.vision.descripcion')"></p>
          <p class="side-code">{{ $t('calidad.vision.codigo') }}</p>
          <hr>
          <h3 class="side-subtitle">{{ $t('calidad.valores.title') }}</h3>
          <p v-html="$t('calidad.valores.descripcion')"></p>
          <p class="side-code">{{ $t('calidad.valores.codigo') }}</p>
          <hr>
        </article>
      </article>
      <!-- Portada -->
      <article class="portada">
        <h2 class="title">{{ $t('inicio.title') }}</h2>
        <p>{{ $t('inicio.detalle') }}</p>
        <div class="btn-opciones">
          <a href="https://cancilleria.gob.bo/mre/wp-content/uploads/2025/11/APOSTILLA-7anos-DIGITAL.pdf" class="btn btn-special btn-large" target="_blank"
            ><i class="icon-checkmark"></i> {{ $t('inicio.btnAniversario') }}</a>
          <router-link class="btn btn-primary btn-large"
            to="/solicitud"><i class="icon-document"></i> {{ $t('inicio.btnSolicitar') }}</router-link>
          <router-link class="btn btn-primary btn-large"
            to="/seguimiento"><i class="icon-search"></i> {{ $t('inicio.btnSeguimiento') }}</router-link>
          <!--<router-link class="btn btn-primary btn-large" to="https://www.rree.gob.bo/VerificaApostilla"><i class="icon-clipboard"></i> {{ $t('inicio.btnVerificar') }}</router-link>-->
          <a href="https://www.rree.gob.bo/VerificaApostilla"
            target="_blank"
            class="btn btn-primary btn-large"><i class="icon-clipboard"></i> {{ $t('inicio.btnVerificar') }}</a>
        </div>
      </article>
    </section>

    <!-- Modal -->
    <article class="modal"
      ref="modal"
      @click="closeModal()">
      <div class="modal-content portada">
        <header><span class="close">&times;</span></header>
        <div class="modal-body">
          <h2 class="title">{{ $t('inicio.modal.title') }}</h2>
          <!-- <p v-html="$t('inicio.modal.important')" style="margin: 0;"></p> -->
          <img src="/static/images/comunicado.jpg" style="width: 100%; height: 50%;" />
          <!-- <p v-html="$t('inicio.modal.header')"></p>

          <ul class="text-left">
            <li>{{ $t('inicio.modal.date') }}</li>
            <li>{{ $t('inicio.modal.number') }}</li>
            <li>{{ $t('inicio.modal.code') }}</li>
          </ul>
          <p class="text-left"
            v-html="$t('inicio.modal.footer')"></p> -->

        </div>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  created () {
    this.modal = sessionStorage.getItem('modal');
  },
  mounted () {
    setTimeout(() => { this.$refs.modal.style.display = 'block'; }, 2500);
  },
  data () {
    return {
      modal: ''
    };
  },
  methods: {
    closeModal () {
      this.$refs.modal.style.display = 'none';
      sessionStorage.setItem('modal', false);
    }
  }
};
</script>

<style lang="scss">
.flex {
  display: flex;
  gap: 20px;
}

.side {
  background-color: rgba(159, 159, 159, 0.1);
  padding: 30px;

  &-title {
    text-align: center;
    font-family: 'Abel';
    font-weight: 600;
    font-size: 1.8em;
    color: #0d5a7e
  }

  &-subtitle {
    font-family: 'Abel';
    font-weight: 600;
    font-size: 1.5em;
    color: #0d5a7e
  }

  & p.side-code {
    text-align: right;
    font-family: 'Abel';
    font-weight: 600;
    font-size: 1em;
  }

  &-detail {
    padding-left: 20px;
  }

  max-width: 600px;
  margin: 50px auto 0;

  p {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    color: #4c4c4c;
    text-align: justify;
  }
}

.portada {
  max-width: 600px;
  margin: 50px auto 0;
  text-align: center;

  p {
    font-size: 1.3rem;
    line-height: 1.8rem;
    font-weight: 400;
    color: #707070;
    text-align: justify;
  }

  .btn-opciones {
    margin-top: 50px;
  }

  .btn-large {
    margin: 0 auto 10px;
    width: 100%;
    max-width: 320px;
    display: block;
    padding: 0 15px;
    line-height: 60px;
    text-align: left;

    [class^="icon-"],
    [class*=" icon-"] {
      font-size: 2rem;
      float: left;
      line-height: 60px;
      margin-right: 10px;
      width: 32px;
    }
  }
}

@media (max-width: 768px) {
  .portada {
    margin-top: 0px;

    .btn-large {
      font-size: .9rem;
    }
  }

  .flex {
    flex-direction: column;
  }
}

.text-left {
  text-align: left;
}

// Modal ---------------------------------
.modal {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 30;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 40%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s
}

.modal-content header {
  padding: 0px 20px;
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {
    top: -300px;
    opacity: 0
  }

  to {
    top: 0;
    opacity: 1
  }
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0
  }

  to {
    top: 0;
    opacity: 1
  }
}

/* The Close Button */
.close {
  color: #000;
  float: right;
  font-size: 36px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  text-decoration: none;
  cursor: pointer;
  color: #707070
}

.modal-body {
  padding: 10px 20px;
}

@media (max-width: 868px) {
  .modal-content {
    width: 95%;
  }
}</style>



// WEBPACK FOOTER //
// src/components/Home.vue